import axios from 'axios'
import { isNumber, trim, get , isString} from 'lodash'
import store from '@/store'
import router from '@/router'

export class API {
  static call (url, params = {}, account, entity, config = {}) {

    entity = entity || (account ? store.state.auth.getEntityByLogin(account.login) : {})
    if (isNumber(entity)) {
      entity = store.state.auth.getEntityByEntityID(entity) || { entity_id: entity }
    }

    if (!params.entity_id && !isString(params)) {
      params.entity_id = entity.entity_id
    }

    url = url.replace(/\$v/, entity.version || 'v1')

    return axios.post(BASE_URL + '/' + trim(url, '/'), params, {
      withCredentials: true,
      ...config
    }).then(resp => {
      return resp.data
    }).catch(err => {

      router.app.$notification.show = true
      router.app.$notification.message = get(err, 'response.data.message', get(err, 'response.message', err.toString()))
      router.app.$notification.type = 'error'

      if (url != '/session.json') {
        store.dispatch('auth/checkSession', {}).then(() => {
          if (!store.state.auth.auth) {
            if (router.app.$route.path !== '/login') router.push(`/login?redirect=${router.app.$route.path}`)
          }
        })
      }
      throw err
    })
  }
}
